import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Column = _resolveComponent("Column")
  const _component_DataTable = _resolveComponent("DataTable")
  const _component_Card = _resolveComponent("Card")

  return (_openBlock(), _createBlock(_component_Card, { class: "p-mt-4" }, {
    content: _withCtx(() => [
      _createVNode(_component_DataTable, {
        value: _ctx.rows,
        class: "p-datatable-sm kn-table",
        responsiveLayout: "scroll",
        loading: _ctx.loading,
        stripedRows: "",
        rowHover: ""
      }, {
        default: _withCtx(() => [
          (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.columns, (col) => {
            return (_openBlock(), _createBlock(_component_Column, {
              field: col.name,
              header: col.header,
              key: col.dataIndex,
              class: "kn-truncated",
              sortable: true
            }, null, 8, ["field", "header"]))
          }), 128))
        ]),
        _: 1
      }, 8, ["value", "loading"])
    ]),
    _: 1
  }))
}